import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-language-switcher',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map